const stats = [
  {
    value: '11.4 GW',
    label: 'Installed wind capacity',
    sub: 'Across Australia as of 2025',
    icon: 'ri-windy-line',
    color: 'text-secondary-600',
    bg: 'bg-secondary-50',
  },
  {
    value: '14%',
    label: 'Electricity from wind',
    sub: 'National grid contribution',
    icon: 'ri-flashlight-line',
    color: 'text-accent-700',
    bg: 'bg-accent-50',
  },
  {
    value: '100+',
    label: 'Wind farms operating',
    sub: 'Commercial scale projects',
    icon: 'ri-landscape-line',
    color: 'text-primary-600',
    bg: 'bg-primary-50',
  },
  {
    value: '$70/MWh',
    label: 'Avg. wind energy cost',
    sub: 'Lowest-cost generation source',
    icon: 'ri-money-dollar-circle-line',
    color: 'text-secondary-600',
    bg: 'bg-secondary-50',
  },
];

export default function WindStats() {
  return (
    <section className="bg-foreground-950 py-14 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className={`w-12 h-12 rounded-xl ${stat.bg} flex items-center justify-center mx-auto mb-4`}>
                <i className={`${stat.icon} text-xl ${stat.color}`}></i>
              </div>
              <div className="font-heading text-3xl md:text-4xl font-extrabold text-white mb-1">
                {stat.value}
              </div>
              <div className="text-sm font-semibold text-white/80 mb-1">{stat.label}</div>
              <div className="text-xs text-white/40">{stat.sub}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}